


class MobileCartCounter extends HTMLElement {
  constructor() {
    super();
    this.cartTextElement = this.querySelector('.cart_mobile');
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      this.fetchCartAndUpdate(); // Always rely on fresh data
    });

    this.fetchCartAndUpdate(); // On page load
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  fetchCartAndUpdate() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        this.updateCartCount(data.item_count);
      });
  }

  updateCartCount(itemCount) {
    if (this.cartTextElement) {
      this.cartTextElement.textContent = `Cart (${itemCount})`;
    }
  }
}

customElements.define('mobile-cart-counter', MobileCartCounter);
